import axios from "./axios";

const PosService = {
    getSections: async (restaurant_id) => {
        try {
            const response = await axios.get(`/restaurants/${restaurant_id}/sections`,{});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getTables: async (restaurant_id) => {
        try {
            const response = await axios.get(`/restaurants/${restaurant_id}/table-types`,{});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getSectionTableMapping: async (restaurant_id) => {
        try {
            const response = await axios.get(`/restaurants/${restaurant_id}/floors/sections`,{});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    createSections: async (data,restaurant_id) => {
        try {
            const response = await axios.post(`/restaurants/${restaurant_id}/sections`, data);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    createTables: async (data, restaurant_id) => {
        try {
           
            const response = await axios.post(`/restaurants/${restaurant_id}/table-types
            `,data);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    mapTablesWithSection: async ( restaurant_id,data) => {
        try {
            const response = await axios.post(`/restaurants/${restaurant_id}/tables
            `,data);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getRestaurentTables: async ( restaurant_id,id=3) => {
        try {
            const response = await axios.get(`/restaurants/${restaurant_id}/tables?employee_id=${id}
            `,{});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getRestaurentTablesForSeating: async ( restaurant_id,id=3) => {
        try {
            const response = await axios.get(`/restaurants/${restaurant_id}/tables
            `,{});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getSectionWithFloor: async (restaurant_id) => {
        try {
            const response = await axios.get(`/pos/floor/section`,{params: {restaurant_id}});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getEmployeeForPos: async (restaurant_id) => {
        try {
            const response = await axios.get(`/employee/pos`,{params: {restaurant_id}});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getEmployeeForPosServer: async (restaurant_id) => {
        try {
            const response = await axios.get(`/employees/pos`);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    posUpdateCart: async (cart_id) => {
        try {
            const response = await axios.put(`/carts/${cart_id}/preparing`,{});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    posCartItemServed: async (rest_id,cart_id,payload) => {
        try {
            const response = await axios.put(`/cart/restaurant/${rest_id}/cart-item/${cart_id}/pos`,payload);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    assignEmployee: async (emp_id,data) => {
        try {
            const response = await axios.post(`/employees/${emp_id}/sections`, data);
            return response.data.data;
        } catch (e) {
            console.error(e);
        } 
    },
    addWaitlist: async (data) => {
        try {
            const response = await axios.post(`/waitlist`, data);
            return response.data.data;
        } catch (e) {
            console.error(e);
        } 
    },
    addToCart: async (res_id,data) => {
        try {
            const response = await axios.post(`/carts/pos`, data);
            return response.data.data;
        } catch (e) {
            console.error(e);
        } 
    },
    posPlaceOrder: async (data) => {
        try {
            const response = await axios.post(`/orders/place-order`, data);
            return response.data.data;
        } catch (e) {
            console.error(e);
        } 
    },
    posSplitOrder: async (data) => {
        try {
            const response = await axios.post(`/orders/split`, data);
            return response.data.data;
        } catch (e) {
            return e.response;
        } 
    },
    posRateOrder: async (data) => {
        try {
            const response = await axios.put(`/rating`, data);
            return response.data.data;
        } catch (e) {
            return e.response;
        } 
    },
    posCustomer: async (data) => {
        try {
            const response = await axios.post(`/customer`, data);
            return response.data.data;
        } catch (e) {
            return e.response;
        } 
    },
    posOrderIssue: async (data) => {
        try {
            const response = await axios.post(`/order-issues`, data);
            return response.data.data;
        } catch (e) {
            return e.response;
        } 
    },
    getPosCart: async (res_id,table_id) => {
        try {
            const response = await axios.get(`/tables/${table_id}/cart`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        } 
    },
    getPosCartStatus: async (res_id,item_id) => {
        try {
            const response = await axios.put(`/cart/restaurant/${res_id}/cart-item/${item_id}/pos`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        } 
    },
    getPosOrder: async (order_id) => {
        try {
            const response = await axios.get(`/order/${order_id}`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        } 
    },
    posMenu: async (restaurant_id) => {
        try {
            const response = await axios.get(`/menus?restaurant_ids=${restaurant_id}&type=POS`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    orderIssues: async (restaurant_id) => {
        try {
            const response = await axios.get(`/order-issues/restaurant/${restaurant_id}`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    issues: async (value) => {
        try {
            const response = await axios.get(`/order-issues/?searchKey=issue&searchValue=${value}`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    deliveryKpi: async (date) => {
        try {
            const response = await axios.get(`/dashboard/delivery?start=${date}`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    ratings: async (id) => {
        try {
            const response = await axios.get(`/rating/${id}`, {});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    posEmployeeTable: async (restaurant_id, employee_id) => {
        try {
            const response = await axios.get(`/pos/employee/table`, { params: { restaurant_id: restaurant_id, employee_id: employee_id }});
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    posWaitlist: async (restaurant_id) => {
        try {
            const response = await axios.get(`/waitlist`, {  });
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    }
    ,
    deleteWaitlist: async (restaurant_id,id) => {
        try {
            const response = await axios.delete(`/waitlist/${id}`, {  });
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },

    deleteIssues: async (id) => {
        try {
            const response = await axios.delete(`/order-issues/${id}`, {  });
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getIssueById: async (id) => {
        try {
            const response = await axios.get(`/order-issues/${id}`, {  });
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    updateOrderIssues: async (id,payload) => {
        try {
            const response = await axios.patch(`/order-issues/${id}`, payload);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    updateWaitlistEWT: async (restaurant_id,id,payload) => {
        try {
            const response = await axios.patch(`/waitlist/${id}`, payload);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    updateTableMapping: async (rest_id,data) => {
        try {
            const response = await axios.patch(`/restaurants/${rest_id}/tables`, data);
            // const response = await axios.patch(`/cart/restaurant/${rest_id}/update-multiple-tables`, data);
            return response.data.data;
        } catch (e) {
            return e?.response?.data;
        } 
    },
};

export default PosService;